export default __webpack_public_path__ + "static/media/kohls.630919fe.svg";